module.exports = __webpack_public_path__ + "static/girl_with_dog.76fd5131.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/girl_with_dog.png
// module id = 146
// module chunks = 35783957827783 40787343088564